import React from 'react';
import styled from 'styled-components';
import { ReactComponent as LogoEntire } from '../../assets/img/logo.svg';
import { styles } from '../../styles/themes/style';
import Button from '../../components/Button';

export const AuthPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: white;
  padding: 40px max(24px, calc((100% - 500px) / 2)) 28px;

  @media (max-width: 768px) {
    padding: 32px 5vw 24px 5vw;
  }
`;

export const AuthInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  max-width: 500px;
  width: 100%;
  background-color: white;
`;

export const AuthOnboardingInnerContainer = styled(AuthInnerContainer)`
  max-width: 500px;
`;

export const AuthOnboardingPageContainer = styled(AuthPageContainer)`
  padding: 40px max(24px, calc((100% - 500px) / 2)) 28px;

  @media (max-width: 768px) {
    padding: 32px 5vw 24px 5vw;
  }
`;

/** Survey + stepper layout (~650px card + 174px stepper + gap). */
export const AuthOnboardingWidePageContainer = styled(AuthPageContainer)`
  padding: 40px max(24px, calc((100% - 920px) / 2)) 28px;

  @media (max-width: 992px) {
    padding: 40px max(24px, calc((100% - 650px) / 2)) 28px;
  }

  @media (max-width: 768px) {
    padding: 32px 5vw 24px 5vw;
  }
`;

export const AuthHeaderBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
`;

export const AuthTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const AuthSubtitleLarge = styled.p`
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${styles.colors.black400};
  margin: 0;
  width: 100%;
`;

export const AuthOnboardingCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 32px;
  width: 100%;
  border: 1px solid ${styles.colors.black200};
  border-radius: 12px;
`;

export const AuthOnboardingCardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 32px;
  width: 100%;
`;

/** Figma: 32px bold, #333951, centered in card */
export const AuthOnboardingPageTitle = styled.h2`
  margin: 0;
  width: 100%;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  color: ${styles.colors.black600};
`;

export const AuthOnboardingCardSubtitle = styled.p`
  margin: 0;
  width: 100%;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #45556c;
`;

export const AuthOnboardingTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const AuthOnboardingCardHero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
`;

export const AuthOnboardingCardHeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const AuthOnboardingIntro = styled.p`
  margin: 0;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${styles.colors.black400};
`;

export const AuthInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  background: ${styles.colors.black100};
  border-radius: 4px;

  p {
    margin: 0;
    flex: 1;
    font-family: NunitoSans;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }
`;

export const AuthSkipLink = styled.button`
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    outline: none;
  }
`;

export const AuthOnboardingActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
`;

export const AuthOnboardingTrustSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
`;

export const AuthOnboardingTrustDivider = styled.div`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid ${styles.colors.black200};
`;

export const AuthTrustRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const AuthTrustItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${styles.colors.black400};

  svg {
    flex-shrink: 0;
  }
`;

export const AuthPageFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
  max-width: 500px;
  padding: 28px 0 15px 0;
  margin-top: auto;
  flex-shrink: 0;
`;

export const AuthColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  width: 100%;
`;

export const FullLogo = styled(LogoEntire)`
  width: 141px;
  height: 32px;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const AuthCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 24px;
  gap: 16px;
  width: 100%;
  min-width: 0;
  overflow: visible;
  border: 1px solid ${styles.colors.black200};
  border-radius: 12px;
`;

export const AuthVerificationCard = styled(AuthCard)`
  gap: 32px;
  align-items: stretch;
`;

export const AuthVerificationCardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
`;

export const AuthCardSectionLabel = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const AuthHintBold = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const AuthResendLink = styled.button`
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black600};
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AuthCardInlineFooter = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const AuthHintRegular = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const EmailClientButton = styled.button`
  box-sizing: border-box;
  width: 100%;
  height: 52px;
  padding: 0 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid ${styles.colors.primary600};
  border-radius: 12px;
  background: ${styles.colors.white};
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${styles.colors.black600};
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    background-color: ${styles.colors.white};
    border-color: ${styles.colors.primary600};
  }

  &:focus {
    outline: none;
  }
`;

export const EmailClientButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const AuthButtonWrap = styled.div`
  width: 100%;

  button {
    border-radius: 12px;
    gap: 10px;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const AuthMethodButton = ({ className, ...props }: React.ComponentProps<typeof Button>) => (
    <AuthButtonWrap className={className}>
        <Button {...props} $height="52px" />
    </AuthButtonWrap>
);

export const OrDivider = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 11px;
  width: 100%;
`;

export const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background: ${styles.colors.black200};
`;

export const DividerLineMuted = styled(DividerLine)`
  background: ${styles.colors.disabledState};
`;

export const OrText = styled.span`
  font-family: NunitoSans;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const AuthFooterText = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const AuthTitle = styled.h1`
  font-family: NunitoSans;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 32px;
  color: ${styles.colors.black600};
  margin: 0;
`;

export const AuthSubtitle = styled.p`
  font-family: NunitoSans;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #45556C;
  margin: 0;
  width: 100%;
`;

export const AuthFormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const AuthField = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${styles.colors.black400};
  text-transform: none;
  letter-spacing: normal;
  cursor: default;
`;

export const AuthFieldLabelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
`;

export const AuthInputWrap = styled.div`
  width: 100%;
  min-width: 0;
  overflow: visible;

  & > div {
    width: 100%;
    min-width: 0;
  }

  && input:not(.email-error) {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 43px;
    padding: 0 12px;
    border-radius: 12px;
    border: 1px solid ${styles.colors.black200};
    background: ${styles.colors.white};
    font-family: NunitoSans;
    font-size: 14px;
    line-height: 20px;
    color: ${styles.colors.black600};

    &::placeholder {
      color: ${styles.colors.black300};
    }

    &:hover,
    &:focus {
      border: 1px solid ${styles.colors.black200};
      outline: none;
    }

    &:disabled {
      background: ${styles.colors.black100};
      border-color: ${styles.colors.black200};
    }
  }

  && input.email-error {
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    height: 43px;
    padding: 0 12px;
    border-radius: 12px;
    border: 1px solid ${styles.colors.red600};
    outline: none;
    box-shadow: none;
  }

  && input.email-error:hover,
  && input.email-error:focus {
    border: 1px solid ${styles.colors.red600};
    outline: none;
    box-shadow: none;
  }
`;

export const AuthPasswordInputWrap = styled(AuthInputWrap)`
  position: relative;

  input {
    padding-right: 40px;
  }
`;

export const AuthPasswordFieldWrap = styled.div`
  width: 100%;
  min-width: 0;
`;

export const AuthPasswordToggle = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${styles.colors.black300};

  &:focus {
    outline: none;
  }
`;

export const AuthFooterTextSmall = styled.p`
  width: 100%;
  margin: 0;
  font-family: NunitoSans;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${styles.colors.black400};
`;

export const PasswordVisibilityIcon = ({ visible }: { visible: boolean }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    style={{ display: 'block', flexShrink: 0 }}
  >
    {visible ? (
      <>
        <path
          d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 2L22 22"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </>
    ) : (
      <>
        <path
          d="M2 12C2 12 5 5 12 5C19 5 22 12 22 12C22 12 19 19 12 19C5 19 2 12 2 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
  </svg>
);

export const AuthLink = styled.span<{ color?: string }>`
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  ${({ color }) => color ? `color: ${color};` : `color: ${styles.colors.primary600};`}
  transition: opacity 0.3s ease 0s;

  &:hover {
    opacity: 0.54;
  }
`;

export const AuthFieldInlineLink = styled(AuthLink)`
  flex-shrink: 0;
  font-size: 14px;
  line-height: 20px;
`;
